
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'

import Card from '~/components/atoms/Card.vue'
import Tag from '~/components/atoms/Tag.vue'
import SexualitySummary from '~/components/molecules/SexualitySummary.vue'
// import SexualityDetail from '~/components/molecules/SexualityDetail.vue'
import { Result } from '~/types/api/result'

export default Vue.extend({
  components: {
    Tag,
    SexualitySummary,
    Card,
  },
  props: {
    result: {
      type: Object,
      required: true,
    } as PropOptions<Result>,
  },
})
